import { useQuery } from '@tanstack/react-query';
import {
  fetchDoctorBikoInsurance,
  PROFILE_BIKO_INSURANCE_QUERY_KEY,
} from '@/modules/profile/functions/fetchDoctorBikoInsurance';
import type { BikoPublicInsuranceData } from '@/modules/profile/utils/bikoInsuranceProfile';

export function useDoctorBikoInsurance(
  userId: string | number | null | undefined,
  options?: { enabled?: boolean; initialData?: BikoPublicInsuranceData | null },
) {
  const enabled = options?.enabled !== false && !!userId;
  return useQuery(
    [PROFILE_BIKO_INSURANCE_QUERY_KEY, userId],
    () => fetchDoctorBikoInsurance(userId!),
    {
      enabled,
      initialData: options?.initialData ?? undefined,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
}
